import React from 'react';

/**
 * PantryMatchBar component - displays a percentage bar showing how many ingredients
 * the user has for a recipe
 * @param {number} percentage - Match percentage (0-100)
 */
function PantryMatchBar({ percentage }) {
  // Determine color based on percentage
  const getBarColor = () => {
    if (percentage >= 75) return '#52cd92'; // Green - high match
    if (percentage >= 50) return '#ffc107'; // Yellow - medium match
    if (percentage >= 25) return '#ff9800'; // Orange - low match
    return '#dc3545'; // Red - very low match
  };

  const barColor = getBarColor();

  return (
    <div style={{ 
      width: '100%', 
      padding: '8px 0',
      margin: '8px 0'
    }}>
      {/* Percentage text */}
      <div style={{
        fontSize: '12px',
        fontWeight: '600',
        color: '#333',
        marginBottom: '4px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span>Pantry Match</span>
        <span style={{ color: barColor }}>{percentage}%</span>
      </div>
      
      {/* Progress bar container */}
      <div style={{
        width: '100%',
        height: '8px',
        backgroundColor: '#e9ecef',
        borderRadius: '4px',
        overflow: 'hidden'
      }}>
        {/* Progress bar fill */}
        <div style={{
          width: `${percentage}%`,
          height: '100%',
          backgroundColor: barColor,
          transition: 'width 0.3s ease',
          borderRadius: '4px'
        }} />
      </div>
    </div>
  );
}

export default PantryMatchBar;

